'use client';

import { AccountSettingsProvider } from '@/components/account-settings-provider';
import { useFCM } from '@/hooks/useFCM';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

export const GlobalProviders = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // don't remove this. this is for the foreground notification initialisation
  const { token } = useFCM();

  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <AccountSettingsProvider>{children}</AccountSettingsProvider>
      </QueryClientProvider>
    </div>
  );
};
